<script setup>
import { cn } from "@/lib/utils";
import { useVModel } from "@vueuse/core";
import { provide } from "vue";
import { ChainOfThoughtContextKey } from "./context";

const props = defineProps({
  modelValue: { type: Boolean, required: false, default: undefined },
  defaultOpen: { type: Boolean, required: false, default: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const isOpen = useVModel(props, "modelValue", emit, {
  defaultValue: props.defaultOpen,
  passive: true,
});

provide(ChainOfThoughtContextKey, isOpen);
</script>

<template>
  <div
    :class="cn('not-prose max-w-prose space-y-4', props.class)"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>
